import { combineActions, handleActions } from 'redux-actions';
import { httpActions } from '@figure/frontlib-onboarding-redux';
import {
  ACTIVATE_PERSONAL_LOAN,
  CREATE_PERSONAL_LOAN,
  GET_PERSONAL_LOAN,
  GET_USER_PERSONAL_LOANS,
  UPDATE_PERSONAL_LOAN,
  UPLOAD_DOCUMENT,
  SAVE_DISBURSE_ACH_PLAID,
  GET_ACTIVE_PERSONAL_LOAN,
  GIACT_ACCOUNT_VERIFICATION,
} from 'actions/personal-loan-actions';
import { APP } from 'store/middleware/app-socket-middleware';
import { SOCKET_OPEN, SOCKET_MESSAGE, SOCKET_CLOSE } from 'actions/ws-actions';
import { WAITING } from 'shared/constants/voe';
import { mergeList, payloadError } from './util';

const { SUCCESS, REQUEST, FAILURE } = httpActions;

export const initialState = {
  personalLoansByUuid: {
    //  '00000000-0000-0000-0000-000000000000': {
    //    active: false,
    //    autopayAccount: {
    //      accountNumber: '',
    //      accountType: '',
    //      accountTypeDescription: '',
    //      achAccountId: '',
    //      ownerName: '',
    //      routingNumber: '',
    //    },
    //    consentsList: [],
    //    crossSellEligible: false,
    //    currentLivingArrangement: '',
    //    desiredLoanAmount: 0,
    //    disburseAccount:
    //      uuid,
    //      accountType,
    //      routingNumber,
    //      accountNumber,
    //      ownerName,
    //      achAccountId
    //   },
    //    documents: [],
    //    employmentVerificationNeeded: false,
    //    hasTShirtSize: false,
    //    identityUuid: '',
    //    income: {
    //      incomePrimary: 0,
    //      incomeCoSigner: 0,
    //      incomeOther: 0,
    //    },
    //    incomeSources: [],
    //    loanNumber: '',
    //    manualPaystubs: [],
    //    payType: 'UNKNOWN',
    //    reason: '',
    //    selectedOffer: {
    //      amount: 0,
    //      aprRate: 0,
    //      rate: 0,
    //      term: 0,
    //      type: '',
    //      originationFeePercentage: 0,
    //      selectedDiscounts: []
    //    },
    //    status: {
    //      applicationUuid: '',
    //      bypassKycReview: true,
    //      bypassVoeReview: WAITING,
    //      creditScoreDecline: false,
    //      crossSellAppStatus: '',
    //      disclosurelistAppReady: false,
    //      disclosurelistClosingComplete: false,
    //      disclosurelistClosingReady: false,
    //      disclosurelistSummaryComplete: false,
    //      disclosurelistSummaryReady: false,
    //      disclosurelistUuid: '',
    //      dtiDecline: false,
    //      employmentVerificationNeeded: false,
    //      giactAccountStatus: 'INITIAL',
    //      hasAal: false,
    //      krangStatus: '',
    //      manualPaystubUpload: false,
    //      manualPaystubTasksComplete: false,
    //      primaryParticipantAcceptsComplete: false,
    //      primaryParticipantAcceptsReady: false,
    //      showDelinquencyReview: false,
    //      softCreditFrozen: false,
    //      softCreditFrozenWithPin: false,
    //      softCreditLocked: false,
    //      softCreditNoMatch: false,
    //      softCreditNoMatchWithSsn: false,
    //      uwDecision: '',
    //      uwSubDecision: '',
    //    },
    //   uuid: '',
    // }
  },
  socketConnected: false,
  loading: false,
  error: '',
};

function merge(state, action) {
  const personalLoanUuid = action.payload.applicationUuid;
  const personalLoan = state.personalLoansByUuid[personalLoanUuid] || {};
  const { selectedOffer = {} } = action.payload;
  const isActive = action.payload.active;
  const activeUuid = isActive ? personalLoanUuid : '';

  return {
    ...state,
    personalLoansByUuid: {
      ...state.personalLoanByUuid,
      [personalLoanUuid]: {
        ...personalLoan,
        active: action.payload.active,
        autopayAccount: {
          ...personalLoan.autopayAccount,
          accountNumber: action.payload.disburseAccount?.accountNumber ?? '',
          accountType: action.payload.disburseAccount?.accountType ?? '',
          accountTypeDescription: action.payload.disburseAccount?.accountTypeDescription ?? '',
          achAccountId: action.payload.disburseAccount?.achAccountId ?? '',
          ownerName: action.payload.disburseAccount?.ownerName ?? '',
          routingNumber: action.payload.disburseAccount?.routingNumber ?? '',
          uuid: action.payload.autopayAccount?.uuid ?? '',
        },
        consentsList: mergeList(personalLoan.consentsList, action.payload.consentsList),
        crossSellEligible: action.payload?.crossSellEligible ?? false,
        currentLivingArrangement: action.payload?.currentLivingArrangement ?? '',
        desiredLoanAmount: action.payload?.desiredLoanAmount ?? 0,
        disburseAccount: {
          ...personalLoan.disburseAccount,
          accountNumber: action.payload.disburseAccount?.accountNumber ?? '',
          accountType: action.payload.disburseAccount?.accountType ?? '',
          accountTypeDescription: action.payload.disburseAccount?.accountTypeDescription ?? '',
          achAccountId: action.payload.disburseAccount?.achAccountId ?? '',
          ownerName: action.payload.disburseAccount?.ownerName ?? '',
          routingNumber: action.payload.disburseAccount?.routingNumber ?? '',
          uuid: action.payload.disburseAccount?.uuid ?? '',
        },
        documents: mergeList(personalLoan.documents, action.payload.documents),
        employmentVerificationNeeded: action.payload?.employmentVerificationNeeded ?? false,
        hasTShirtSize: action.payload?.hasTShirtSize ?? false,
        identityUuid: action.payload.identityUuid,
        income: {
          incomePrimary: action.payload.income?.incomePrimary ?? 0,
          incomeCoSigner: action.payload.income?.incomeCoSigner ?? 0,
          incomeOther: action.payload.income?.incomeOther ?? 0,
        },
        incomeSources: action.payload.incomeSources,
        loanNumber: action.payload.loanNumber,
        manualPaystubs: action.payload.manualPaystubs,
        payType: action.payload.payType,
        reason: action.payload?.reason ?? '',
        selectedOffer: {
          ...personalLoan.selectedOffer,
          amount: selectedOffer?.amount ?? 0,
          aprRate: selectedOffer?.aprRate ?? 0,
          rate: selectedOffer?.rate ?? 0,
          term: selectedOffer?.term ?? 0,
          rateType: selectedOffer?.rateType ?? '',
          originationFeePercentage: selectedOffer?.originationFeePercentage ?? 0,
          selectedDiscounts: selectedOffer?.selectedDiscounts ?? [],
        },
        status: {
          ...personalLoan.status,
          applicationUuid: action.payload.status?.applicationUuid ?? '',
          bypassKycReview: action.payload.status?.bypassKycReview ?? true,
          bypassVoeReview: action.payload.status?.bypassVoeReview ?? WAITING,
          creditScoreDecline: action.payload.status?.creditScoreDecline ?? false,
          crossSellAppStatus: action.payload.status?.crossSellAppStatus ?? [],
          declineCodes: action.payload.status?.declineCodes ?? [],
          disclosurelistAppReady: action.payload.status?.disclosurelistAppReady ?? false,
          disclosurelistClosingComplete:
            action.payload.status?.disclosurelistClosingComplete ?? false,
          disclosurelistClosingReady: action.payload.status?.disclosurelistClosingReady ?? false,
          disclosurelistSummaryComplete:
            action.payload.status?.disclosurelistSummaryComplete ?? false,
          disclosurelistSummaryReady: action.payload.status?.disclosurelistSummaryReady ?? false,
          disclosurelistUuid: action.payload.status?.disclosurelistUuid ?? '',
          dtiDecline: action.payload.status?.dtiDecline ?? false,
          giactAccountStatus: action.payload.status?.giactAccountStatus ?? '',
          hasAal: action.payload.status?.hasAal ?? false,
          krangStatus: action.payload.status?.krangStatus ?? '',
          manualPaystubUpload: action.payload.status?.manualPaystubUpload,
          manualPaystubTasksComplete: action.payload.status?.manualPaystubTasksComplete,
          primaryParticipantAcceptsComplete:
            action.payload.status?.primaryParticipantAcceptsComplete ?? false,
          primaryParticipantAcceptsReady:
            action.payload.status?.primaryParticipantAcceptsReady ?? false,
          showDelinquencyReview: action.payload.status?.showDelinquencyReview ?? false,
          softCreditFrozen: action.payload.status?.softCreditFrozen ?? false,
          softCreditFrozenWithPin: action.payload.status?.softCreditFrozenWithPin ?? false,
          softCreditLocked: action.payload.status?.softCreditLocked ?? false,
          softCreditNoMatch: action.payload.status?.softCreditNoMatch ?? false,
          softCreditNoMatchWithSsn: action.payload.status?.softCreditNoMatchWithSsn ?? false,
          uwDecision: action.payload.status?.uwDecision ?? '',
          uwSubDecision: action.payload.status?.uwSubDecision ?? '',
        },
        uuid: personalLoanUuid,
      },
    },
    activeUuid,
    loading: false,
    error: '',
  };
}

const reducer = handleActions(
  {
    [ACTIVATE_PERSONAL_LOAN](state = initialState, action) {
      return {
        ...state,
        activeUuid: action.payload,
      };
    },
    // @ts-ignore
    [combineActions(
      `${UPDATE_PERSONAL_LOAN}_${REQUEST}`,
      `${UPLOAD_DOCUMENT}_${REQUEST}`,
      `${SAVE_DISBURSE_ACH_PLAID}_${REQUEST}`
    )](state = initialState) {
      return {
        ...state,
        error: '',
      };
    },
    // @ts-ignore
    [combineActions(
      `${CREATE_PERSONAL_LOAN}_${REQUEST}`,
      `${GET_PERSONAL_LOAN}_${REQUEST}`,
      `${GET_ACTIVE_PERSONAL_LOAN}_${REQUEST}`,
      `${GET_USER_PERSONAL_LOANS}_${REQUEST}`,
      `${GIACT_ACCOUNT_VERIFICATION}_${REQUEST}`
    )](state = initialState) {
      return {
        ...state,
        error: '',
        loading: true,
      };
    },
    // @ts-ignore
    [combineActions(
      `${SAVE_DISBURSE_ACH_PLAID}_${FAILURE}`,
      `${UPDATE_PERSONAL_LOAN}_${FAILURE}`,
      `${UPLOAD_DOCUMENT}_${FAILURE}`,
      `${UPDATE_PERSONAL_LOAN}_${FAILURE}`,
      `${GIACT_ACCOUNT_VERIFICATION}_${FAILURE}`
    )](state, action) {
      return {
        ...state,
        error: payloadError(action),
      };
    },
    // @ts-ignore
    [combineActions(
      `${CREATE_PERSONAL_LOAN}_${SUCCESS}`,
      `${GET_PERSONAL_LOAN}_${SUCCESS}`,
      `${GET_ACTIVE_PERSONAL_LOAN}_${SUCCESS}`,
      `${UPLOAD_DOCUMENT}_${SUCCESS}`,
      `${SAVE_DISBURSE_ACH_PLAID}_${SUCCESS}`,
      `${UPDATE_PERSONAL_LOAN}_${SUCCESS}`,
      `${GIACT_ACCOUNT_VERIFICATION}_${SUCCESS}`
    )](state, action) {
      return merge(state, action);
    },
    [`${APP}_${SOCKET_OPEN}`](state) {
      return {
        ...state,
        socketConnected: true,
      };
    },
    [`${APP}_${SOCKET_MESSAGE}`](state, action) {
      // @ts-ignore
      const payload = JSON.parse(action.payload);
      const personalLoanUuid = payload.applicationUuid;

      const personalLoan = state.personalLoansByUuid[personalLoanUuid];
      if (!personalLoan) return state;

      const status = payload;

      return {
        ...state,
        personalLoansByUuid: {
          ...state.personalLoansByUuid,
          [personalLoanUuid]: {
            ...personalLoan,
            status: {
              ...personalLoan.status,
              bypassKycReview: status?.bypassKycReview ?? true,
              bypassVoeReview: status?.bypassVoeReview ?? WAITING,
              creditScoreDecline: status.creditScoreDecline,
              crossSellAppStatus: status.crossSellAppStatus,
              declineCodes: status.declineCodes,
              disclosurelistAppReady: status.disclosurelistAppReady,
              disclosurelistClosingComplete: status.disclosurelistClosingComplete,
              disclosurelistClosingReady: status.disclosurelistClosingReady,
              disclosurelistSummaryComplete: status.disclosurelistSummaryComplete,
              disclosurelistSummaryReady: status.disclosurelistSummaryReady,
              disclosurelistUuid: status.disclosurelistUuid,
              dtiDecline: status.dtiDecline,
              giactAccountStatus: status.giactAccountStatus,
              hasAal: status.hasAal,
              krangStatus: status.krangStatus,
              primaryParticipantAcceptsComplete: status.primaryParticipantAcceptsComplete,
              primaryParticipantAcceptsReady: status.primaryParticipantAcceptsReady,
              showDelinquencyReview: status?.showDelinquencyReview ?? false,
              softCreditFrozen: status.softCreditFrozen,
              softCreditFrozenWithPin: status.softCreditFrozenWithPin,
              softCreditLocked: status.softCreditLocked,
              softCreditNoMatch: status.softCreditNoMatch,
              softCreditNoMatchWithSsn: status.softCreditNoMatchWithSsn,
              uwDecision: status.uwDecision,
              uwSubDecision: status.uwSubDecision,
            },
          },
        },
      };
    },
    [`${APP}_${SOCKET_CLOSE}`](state) {
      return {
        ...state,
        socketConnected: false,
      };
    },
  },
  initialState
);

export default reducer;
